import { ReactComponent as SkipPrevious } from '@public/icons/skip-previous.svg';
import Icon from '../atoms/Icon';

const IconSkipPrevious = (props) => <Icon as={SkipPrevious} {...props} />;

IconSkipPrevious.propTypes = Icon.propTypes;

export default IconSkipPrevious;
